function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconCafe(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.72852 5.014C2.72852 4.17811 3.37969 3.50049 4.18297 3.50049H12.9097C13.713 3.50049 14.3641 4.17811 14.3641 5.014H16.0263C17.1165 5.014 18.0002 5.93364 18.0002 7.06806C18.0002 9.65868 16.1567 11.8013 13.7604 12.1527C12.8544 13.9804 11.0224 15.2302 8.90993 15.2302H8.1827C5.17044 15.2302 2.72852 12.6891 2.72852 9.55455V5.014ZM14.213 10.8868C15.7754 10.3789 16.9094 8.86128 16.9094 7.06806C16.9094 6.56055 16.514 6.14914 16.0263 6.14914H14.3641V9.55455C14.3641 10.0134 14.3118 10.4595 14.213 10.8868Z",
    style: {
      fill: "var(--icon-color, currentColor)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.54542 16.365C2.24419 16.365 2 16.6191 2 16.9326C2 17.246 2.24419 17.5001 2.54542 17.5001H14.5446C14.8459 17.5001 15.0901 17.246 15.0901 16.9326C15.0901 16.6191 14.8459 16.365 14.5446 16.365H2.54542Z",
    style: {
      fill: "var(--icon-color, currentColor)"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCafe);
export default __webpack_public_path__ + "static/media/icon-cafe.e0e260665a98251396a6b5618cc2d9f3.svg";
export { ForwardRef as ReactComponent };